import { SELECTOR, setSelector } from '@socialive/common';
import toast from './toast';

const selectToast = () => toast;

setSelector(SELECTOR.TOAST, selectToast);

export default selectToast;
